import {ObjectNode} from "#template/nodes/object/object-node"
import type {ObjectNodeConstructorParameters, ObjectNodeParameters} from "#template/nodes/object/types"

export abstract class LightNode<
    out Parameters extends ObjectNodeParameters = ObjectNodeParameters,
    out ConstructorParameters extends ObjectNodeConstructorParameters = Omit<Parameters, "visible"> & {visible?: boolean},
> extends ObjectNode<Parameters, ConstructorParameters> {}
